<template>
  <div>
    <el-popover
      ref="popover"
      @show="showPopover = true"
      @hide="showPopover = false"
      v-model="showPopover"
      placement="bottom"
      width="600"
      trigger="click"
    >
      <el-input
        :value="selectValue"
        slot="reference"
        placeholder="请选择角色"
        :suffix-icon="showPopover ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        readonly
      ></el-input>
      <div style="position: relative; height: 25px" v-if="showPopover">
        <i
          @click="showPopover = false"
          class="el-icon-close"
          style="font-size: large; position: absolute; right: 0px"
        ></i>
      </div>
      <el-transfer
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入权限名称"
        :value="selectIdList"
        :data="data"
        @change="selectChange"
        :props="{
          key: 'id',
          label: 'name',
        }"
        :titles="['未选角色', '已选角色']"
      >
      </el-transfer>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "RoleTransfer",
  props: {
    value: [Array],
    parentData: [],
  },
  computed: {
    selectValue() {
      if (
        this.selectIdList &&
        this.selectIdList.length > 0 &&
        this.data &&
        this.data.length > 0
      ) {
        let r = this.data.filter((d) => {
          return this.selectIdList.indexOf(d.id) > -1;
        });
        if (r && r.length > 0) {
          return r
            .map((item) => {
              return item.name;
            })
            .join(",");
        }
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        this.selectIdList = this.value;
      },
      immediate: true,
      deep:true
    },
  },
  data() {
    return {
      showPopover: false,
      selectIdList: [],
      data: [],
    };
  },
  methods: {
    async flushData() {
      if (this.parentData && this.parentData.length > 0) {
        this.data = this.parentData;
      } else {
        let leftRequestRes = await this.$api.sysRole_findUnfrozenList({
          showLoading: false,
        });
        if (leftRequestRes && leftRequestRes.data) {
          this.data = leftRequestRes.data;
        }
      }
    },
    filterMethod(query, item) {
      return item.name.indexOf(query) > -1;
    },
    selectChange(v, d, k) {
      this.selectIdList = v;
      this.$emit("input", v);
      this.$emit("change", v);
    },
  },
  mounted() {
    this.flushData();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/RoleTransfer.vue